/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} You_KeepInputs */

const en_you_keep = /** @type {(inputs: You_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You keep`)
};

const es_you_keep = /** @type {(inputs: You_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tú conservas`)
};

const fr_you_keep = /** @type {(inputs: You_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous conservez`)
};

const de_you_keep = /** @type {(inputs: You_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du behältst`)
};

const ja_you_keep = /** @type {(inputs: You_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたの収益の`)
};

const zh_you_keep = /** @type {(inputs: You_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您将保留`)
};

const ar_you_keep = /** @type {(inputs: You_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنت تحتفظ بـ`)
};

const id_you_keep = /** @type {(inputs: You_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda menyimpan`)
};

const it_you_keep = /** @type {(inputs: You_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trattieni il`)
};

const ru_you_keep = /** @type {(inputs: You_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы получаете`)
};

const pt_you_keep = /** @type {(inputs: You_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você mantém`)
};

const ko_you_keep = /** @type {(inputs: You_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수익의`)
};

/**
* | output |
* | --- |
* | "You keep" |
*
* @param {You_KeepInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const you_keep = /** @type {((inputs?: You_KeepInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<You_KeepInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_you_keep(inputs)
	if (locale === "es") return es_you_keep(inputs)
	if (locale === "fr") return fr_you_keep(inputs)
	if (locale === "de") return de_you_keep(inputs)
	if (locale === "ja") return ja_you_keep(inputs)
	if (locale === "zh") return zh_you_keep(inputs)
	if (locale === "ar") return ar_you_keep(inputs)
	if (locale === "id") return id_you_keep(inputs)
	if (locale === "it") return it_you_keep(inputs)
	if (locale === "ru") return ru_you_keep(inputs)
	if (locale === "pt") return pt_you_keep(inputs)
	return ko_you_keep(inputs)
});